import { render, staticRenderFns } from "./ProceduresForm.vue?vue&type=template&id=39a0e074&scoped=true"
import script from "./ProceduresForm.vue?vue&type=script&lang=js"
export * from "./ProceduresForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a0e074",
  null
  
)

export default component.exports